import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex justify-end gap-6" }
const _hoisted_2 = {
  id: "charger",
  class: "mr-2 mb-4 mt-8 font-roboto text-white flex justify-end lg:mb-0"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "text-white mx-12 font-roboto lg:grid lg:grid-cols-2 md:mx-20 2xl:mx-40" }
const _hoisted_5 = { class: "text-center lg:text-start lg:pt-16 lg:sticky lg:top-20 lg:h-[calc(100vh-117px)] lg:mr-16" }
const _hoisted_6 = { class: "mt-12 lg:mt-8 lg:ml-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MySocialsMobile = _resolveComponent("MySocialsMobile")!
  const _component_NameAndProfession = _resolveComponent("NameAndProfession")!
  const _component_AboutMe = _resolveComponent("AboutMe")!
  const _component_MyTechnologies = _resolveComponent("MyTechnologies")!
  const _component_DownloadCv = _resolveComponent("DownloadCv")!
  const _component_MySocials = _resolveComponent("MySocials")!
  const _component_ProfessionalExperience = _resolveComponent("ProfessionalExperience")!
  const _component_MyProjects = _resolveComponent("MyProjects")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MySocialsMobile),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
          class: "cursor-pointer bg-black"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
            return (_openBlock(), _createElementBlock("option", {
              key: `locale-${locale}`,
              value: locale
            }, _toDisplayString(locale), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.$i18n.locale]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NameAndProfession),
        _createVNode(_component_AboutMe),
        _createVNode(_component_MyTechnologies),
        _createVNode(_component_DownloadCv),
        _createVNode(_component_MySocials)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ProfessionalExperience),
        _createVNode(_component_MyProjects)
      ])
    ])
  ], 64))
}